import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import {getFlatDataFromTree} from 'react-sortable-tree'
const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: 0 ,
        width: "100%",
    },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: "25em"
        }
    },
    getContentAnchorEl: () => null
};

export default function SelectSteps (props) {
    const classes = useStyles();
    const flatSteps = getFlatDataFromTree({
            treeData: props.steps,
            getNodeKey: (({ node }) => node._id),
            ignoreCollapsed: false,
        }).map(node => {
            return node.node
        });
    const handleChange = (event) => {
        let id = event.currentTarget.dataset.value
        props.addItemToStep(id, props.infoItem)
    };
    return (
        <div>
            <FormControl className={classes.formControl}>
                <InputLabel id="demo-mutiple-checkbox-label" shrink={true}></InputLabel>
                <Select
                    labelId="demo-mutiple-checkbox-label"
                    id="demo-mutiple-checkbox"
                    multiple
                    disabled={props.isGlobal}
                    value={props.selectedStepsIds}
                    onChange={handleChange}
                    input={<Input />}
                    renderValue={() => {
                        let selectedSteps = flatSteps.filter(step => {
                            return props.selectedStepsIds.includes(step._id)
                        })
                        let count = selectedSteps.length || 0
                        return `${props.isGlobal ? `All Steps Selected` : `${ count } Step(s) Selected`}`
                    }}
                    MenuProps={MenuProps}
                    //This is very touchy, do not change unless you want to put the column out of wack
                    style={{ width: "100%", height: '26px' }}
                >
                    {flatSteps.map(step => {
                    return <MenuItem key={step._id} value={step._id}>
                            <Checkbox checked={props.selectedStepsIds.includes(step._id)} />
                            <ListItemText primary={`${step.title}`} />
                        </MenuItem>
                })}
                </Select>
            </FormControl>
        </div>
    );
}